import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useState } from "react";
import { useNavigate } from "react-router";
import LoginService from 'service/login/LoginService';
import './login.scss';
import { useLoadingContext } from 'provider/LoadingProvider';
import { Password } from 'primereact/password';

const loginService = new LoginService();

export default function Login() {
    const [mensagem, setMensagem] = useState('');
    const [mensagemAlerta, setMensagemAlerta] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const navigate = useNavigate();

    const { startLoading, stopLoading } = useLoadingContext();

    function login() {

        setMensagem('');
        startLoading();
        loginService.logar(email, senha)
            .then(retorno => {
                console.log(retorno);
                localStorage.setItem('token', retorno.token);
                window.location.reload();
                stopLoading();
            }).catch(e => {
                console.error(e);
                setMensagem('Não foi possível realizar o acesso');
                stopLoading();
            });

    }

    const keyDownSenha = (e: any) => {
        if (e.getModifierState("CapsLock")) {
            setMensagemAlerta('Caps Lock está ativado');
        } else {
            setMensagemAlerta('');
        }
        if (e.key === 'Enter') {
            login();
        }
    }

    return (
        <div className="login">

            <div className="login-center">


                <img src='/empx.png' className="login-img-logo" alt="logo" />

                {
                    mensagem && (
                        <div style={{ marginBottom: 20, boxSizing: "unset" }}>
                            <span style={{ color: '#990000', backgroundColor: '#ffa7a7ff', padding: 10, marginBottom: 1, border: '#00d0ff00', borderRadius: 5 }}>{mensagem}</span>
                        </div>
                    )
                }

                {
                    mensagemAlerta && (
                        <div style={{ marginBottom: 20, boxSizing: "unset" }}>
                            <span style={{ color: '#666600', backgroundColor: '#ffffa7ff', padding: 10, marginBottom: 1, border: '#00d0ff00', borderRadius: 5 }}>{mensagemAlerta}</span>
                        </div>
                    )
                }

                <div className="row">
                    <div className="col-sm-12">
                        <InputText className="login-input" autoFocus={true} type="email" id="email" name="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <Password
                            className='login-input'
                            placeholder='Senha'
                            inputStyle={{ width: "100%" }}
                            value={senha}
                            onChange={(e) => setSenha(e.target.value)}
                            feedback={false}
                            toggleMask
                            onKeyDown={keyDownSenha}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <Button className='login-botao' label="Entrar" onClick={() => login()} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <a href='/recuperarsenha'>Esqueci a senha</a>
                    </div>
                </div>

            </div>

        </div>
    )
}